<template>
  <div>
    <h3 class="d-flex text--darken-1">
      <span>Allergies <small><i>(Click a record to update)</i></small></span>
      <base-popup-btn
        v-if="consultation.status != 'submitted'"
        class="ml-auto"
        @click="addAllergy"
      >
        Add Allergy
      </base-popup-btn>
    </h3>

    <v-row>
      <v-col cols="12">
        <base-table
          :headers="headers"
          :items="allergies"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="updateAllergy(index)" >
              <td>
                <span v-if="item.Id" class="hidden">{{ item.Id }}</span>
                {{ item.Allergy }}
              </td>
              <td>
                {{ item.Note }}
              </td>
            </tr>
          </template>
        </base-table>
      </v-col>
    </v-row>

    <!-- ALLERGY DIALOG -->
    <v-dialog
     v-model="allergyDialog"
     content-class="elevation-0"
     width="70vw"
     max-width="600px" 
    >
      <v-card>
        <v-card-title class="primary--text">Allergy</v-card-title>
        
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <!-- Allergy -->
            <v-text-field
              v-model="allergy"
              placeholder=" "
              :rules="rules.required"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.allergy = `${this.allergy || ''} ${text}`;}, 'allergy')}"
              v-on:click="() => {this.$vtt.setModel('allergy');}"
            >
              <template v-slot:label>
                <h3>Allergy <span class="red--text">*</span></h3>
              </template>
            </v-text-field>

            <!-- Note -->
            <v-textarea
              v-model="note"
              placeholder=" "
              rows="3"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.note = `${this.note || ''} ${text}`;}, 'note')}"
              v-on:click="() => {this.$vtt.setModel('note');}"
            >
              <template v-slot:label>
                <h3>Note</h3>
              </template>
            </v-textarea>
            <VTTButton :mode="'checkbox'"/>
          </v-form>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="d-flex justify-center">
          <!-- Add/ Update Button -->
          <v-btn
            rounded
            small
            color="primary"
            class="px-6 mx-2"
            @click="saveAllergy"
          >
            {{ allergyUpdate?'Update':'Add' }}
          </v-btn>

          <!-- Remove Button -->
          <v-btn
            rounded
            small
            color="error"
            class="px-6 mx-2"
            v-if="allergyUpdate"
            @click="removeAllergy"
          >Remove</v-btn>

          <!-- Cancel Button -->
          <v-btn
            rounded
            small
            color="primary lighten-5"
            class="px-6 mx-2 primary--text"
            @click="cancelAllergy"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import VTTButton from '../../../../../components/custom/VTTButton.vue'
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';
  export default {
    name: 'PatientAllergy',
    components: { VTTButton },

    mixins: [textreplacementmixin],

    data: () => ({
      valid: false,
      rules: {
       required: [value => !!value || "This field is required."]
      },
      allergyDialog: false,
      allergyUpdate: false,
      headers: [
        { text: 'Allergy', value: 'allergy', class:'primary--text' },
        { text: 'Note', value: 'note', class:'primary--text' },
      ]
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      consultation() { return this.$store.getters['consultation/activeInfo'] },
      allergies: {
        get() { return this.$store.getters['patient/allergies'] },
        set(val) { this.$store.commit('patient/updateAllergies', val) }
      },

      allergy: {
        get() { return this.$store.getters['patient/allergy'] },
        set(val) { this.$store.commit('patient/updateAllergy', val) }
      },

      note: {
        get() { return this.$store.getters['patient/note'] },
        set(val) { this.$store.commit('patient/updateNote', val) }
      },

      type: {
        get() { return this.$store.getters['allergy/type'] },
        set(val) { this.$store.commit('allergy/updateType', val) }
      },
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    methods: {
      addAllergy() {
        this.$store.commit('patient/clearAllergy');
        this.allergyDialog = true;
        this.allergyUpdate = false;
      },

      updateAllergy(index) {
        this.allergyDialog = true;
        this.allergyUpdate = true;
        this.$store.commit('patient/setActiveAllergy', index);
      },

      cancelAllergy() {
        this.$refs.form.resetValidation();
        this.allergyDialog = false;
        this.allergyUpdate = false;
      },

      saveAllergy() {
        this.$refs.form.validate();
        if (this.valid) {
          if (this.allergyUpdate) {
            var index = this.$store.getters['patient/setActiveAllergy'];
            this.$store.commit('patient/editAllergy', index);
            this.allergyDialog = false;
          } else {
            this.$store.commit('patient/addAllergy');
            this.$store.commit('patient/clearAllergy');
            this.allergyDialog = false;
          }
        }
      },

      removeAllergy() {
        this.$store.commit('patient/removeAllergy');
        this.allergyDialog = false;
      },
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    mounted() {
      console.log("allergies");
      console.log(this.$store.getters['patient/allergies']);
    }

  }
</script>

<style lang="scss" scoped>
  .hidden { display: none; }
</style>